import checkContactUsButtonShouldBeShown from "./helpers/checkContactUsButtonShouldBeShown";
import ContactUsForm from "./components/ContactUsForm";
import FloatingButton from "./components/FloatingButton";

import { createPortal } from "react-dom";
import { memo, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import { useParams } from "react-router-dom";

import styles from "./promoContactUsFloatingButton.module.scss";

/**
 * PromoContactUsFloatingButton component is a floating button that is displayed
 * on the promo page. When the user clicks on the button, the ContactUsForm
 * component is displayed.
 */
const PromoContactUsFloatingButton = () => {
  const [showForm, setShowForm] = useState(false);
  const { getDirection } = useContent();
  const params = useParams();

  const shouldBeShown = checkContactUsButtonShouldBeShown(params);

  if (!shouldBeShown) {
    return null;
  }

  return createPortal(
    <div className={styles.wrapper} dir={getDirection()}>
      <FloatingButton showForm={showForm} setShowForm={setShowForm} />
      <ContactUsForm showForm={showForm} setShowForm={setShowForm} />
    </div>,
    document.body
  );
};

export default memo(PromoContactUsFloatingButton);
